export default __webpack_public_path__ + "static/media/mode-70.5e45b40e.svg";